// extracted by mini-css-extract-plugin
module.exports = {"form":"styles__form__3XIDO"};